<div class="card-columns">
    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 기본설정
        </div>
        <div class="card-body">
            <div class="form-group">
                <label class="">운송사업자명</label>
                <input type="text" class="form-control">
            </div>
            <div class="form-group">
                <label class="">사업자등록번호</label>
                <input type="text" class="form-control">
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 과속지표
        </div>
        <div class="card-body">
            <div class="form-group">
                <label class="">과속 (km/h)</label>
                <input type="number" class="form-control" min="1" max="300" value="100">
            </div>
            <div class="form-group">
                <label class="">장기과속 (초)</label>
                <input type="number" class="form-control" min="1" max="300" value="60">
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 안전운행지표
        </div>
        <div class="card-body">
            <div class="form-group">
                <label class="">과속 (km/h)</label>
                <input type="number" class="form-control" min="1" max="300" value="100">
            </div>
            <div class="form-group">
                <label class="">장기과속 (초)</label>
                <input type="number" class="form-control" min="1" max="300" value="60">
            </div>
            <div class="form-group">
                <label class="">공회전 (분)</label>
                <input type="number" class="form-control" min="1" max="300" value="5">
            </div>
            <div class="form-group">
                <label class="">급가속 (km/h)</label>
                <input type="number" class="form-control" min="1" max="300" value="5">
            </div>
            <div class="form-group">
                <label class="">급감속 (km/h)</label>
                <input type="number" class="form-control" min="1" max="300" value="100">
            </div>
            <div class="form-group">
                <label class="">급제동 (초)</label>
                <input type="number" class="form-control" min="1" max="300" value="60">
            </div>
            <div class="form-group">
                <label class="">급출발 (분)</label>
                <input type="number" class="form-control" min="1" max="300" value="5">
            </div>
            <div class="form-group">
                <label class="">급정지 (km/h)</label>
                <input type="number" class="form-control" min="1" max="300" value="5">
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 운행정보표시
        </div>
        <div class="card-body">
            <div class="custom-control custom-radio">
                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input" checked>
                <label class="custom-control-label" for="customRadio1">운행차량만 (기본)</label>
            </div>
            <div class="custom-control custom-radio mt-2">
                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input">
                <label class="custom-control-label" for="customRadio2">미운행 차량 포함</label>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 운행정보구간
        </div>
        <div class="card-body">
            <div class="custom-control custom-radio">
                <input type="radio" id="customRadio3" name="customRadio2" class="custom-control-input" checked>
                <label class="custom-control-label" for="customRadio3">운행시작 ~ 운행종료 (기본)</label>
            </div>
            <div class="custom-control custom-radio mt-2">
                <input type="radio" id="customRadio4" name="customRadio2" class="custom-control-input">
                <label class="custom-control-label" for="customRadio4">24시간 전체</label>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-transparent border-bottom">
            <i class="far fa-edit"></i> 다운로드구간
        </div>
        <div class="card-body">
            <div class="custom-control custom-radio">
                <input type="radio" id="customRadio5" name="customRadio3" class="custom-control-input" checked>
                <label class="custom-control-label" for="customRadio5">전일까지만 (기본)</label>
            </div>
            <div class="custom-control custom-radio mt-2">
                <input type="radio" id="customRadio6" name="customRadio3" class="custom-control-input">
                <label class="custom-control-label" for="customRadio6">현재월 전체</label>
            </div>
        </div>
    </div>
</div>